import EntityContext from './EntityContext';
import EntityNoData from 'components/EntityNoData';
import EntityPageShell from '../EntityPageShell';

/**
 * An entity page: the frame, and the entity every block inside it reads.
 *
 * `children` is the page's own content - hero, chart - and sits in the heading
 * column when a `title` is given. `sections` and `tabs` are siblings below it,
 * in that order, because that is where the frame puts them.
 */
const EntityPage = ({
    page,
    breadcrumbs = null,
    sourceTabs,
    title,
    actions = null,
    space,
    sections = null,
    tabs = null,
    children,
}) => {
    if (page.coverageFailed || page.isEmpty)
        return (
            <EntityNoData
                entityId={page.entityId}
                entityType={page.entityType}
                dataSource={page.dataSource}
                {...(sourceTabs !== undefined && { tabs: sourceTabs })}
            />
        );

    return (
        <EntityContext.Provider value={page}>
            <EntityPageShell
                breadcrumbs={breadcrumbs}
                tabs={sourceTabs ?? null}
                title={title}
                actions={actions}
                {...(space !== undefined && { space })}
                sections={
                    sections || tabs ? (
                        <>
                            {sections}
                            {tabs}
                        </>
                    ) : null
                }
            >
                {children}
            </EntityPageShell>
        </EntityContext.Provider>
    );
};

export default EntityPage;
